import {
  GeneratePurchaseOrderPayloadSupplyItemProps,
  SupplyItemsPreviewResponseSaleOrderItem,
  SupplyItemsPreviewResponseSupplyOrderItem,
} from '@/types'
import { ExcludedItemsProps } from './select-supplier-order-items.type'

export const getAvailableQuantity = (
  item: SupplyItemsPreviewResponseSupplyOrderItem,
  supplyItem: GeneratePurchaseOrderPayloadSupplyItemProps,
): number => {
  const supplyItemQuantity = supplyItem?.quantity || 0
  const itemQuantity = item?.availableQuantity || 0

  return Math.max(0, itemQuantity - supplyItemQuantity)
}

export const getSupplyOrderItemValueByCurrency = (
  item: SupplyItemsPreviewResponseSupplyOrderItem,
  currency: 'MXN' | 'USD',
  dollarExchangeRate: string,
  currencySupplyOrderItem: 'MXN' | 'USD',
): number => {
  const cost = +(item?.cost || 0)
  return currency === currencySupplyOrderItem
    ? cost
    : currency === 'USD'
      ? cost / +dollarExchangeRate
      : cost * +dollarExchangeRate
}

export const totalSupplyOrderItemValue = (
  item: SupplyItemsPreviewResponseSupplyOrderItem,
  quantity: number,
  currency: 'MXN' | 'USD',
  dollarExchangeRate: string,
  currencySupplyOrderItem: 'MXN' | 'USD',
) => {
  const total =
    getSupplyOrderItemValueByCurrency(
      item,
      currency,
      dollarExchangeRate,
      currencySupplyOrderItem,
    ) * quantity

  return total
}

export const getSupplyItemsByPayload = (
  saleOrderUuid: string,
  saleOrderItemUuid: string,
  supplyItemUuid: string,
  saleOrdersToPayload: Record<
    string,
    Record<string, GeneratePurchaseOrderPayloadSupplyItemProps[]>
  >,
): GeneratePurchaseOrderPayloadSupplyItemProps | undefined => {
  return (
    saleOrdersToPayload?.[saleOrderUuid]?.[saleOrderItemUuid]?.find(
      (supplyItem) => supplyItem?.uuid === supplyItemUuid,
    ) || undefined
  )
}

export const getSupplyItemCompletionStatus = (
  saleOrderUuid: string,
  saleOrderItem: SupplyItemsPreviewResponseSaleOrderItem,
  saleOrdersToPayload: Record<
    string,
    Record<string, GeneratePurchaseOrderPayloadSupplyItemProps[]>
  >,
) => {
  const totalQuantity = saleOrderItem?.missingQuantity || 0

  let filledQuantity = 0

  saleOrdersToPayload[saleOrderUuid]?.[saleOrderItem?.uuid || '']?.forEach(
    (supplyItem) => {
      filledQuantity += supplyItem?.quantity || 0
    },
  )

  const percentage =
    totalQuantity > 0
      ? Math.min(100, Math.round((filledQuantity / totalQuantity) * 100))
      : 0

  return {
    filledQuantity,
    percentage,
  }
}

export const listWithoutExcludedItems = (
  items: SupplyItemsPreviewResponseSupplyOrderItem[],
  excludeItems: ExcludedItemsProps,
): SupplyItemsPreviewResponseSaleOrderItem[] => {
  return items.filter((item) => !excludeItems[item?.uuid || ''])
}

export const formattedExcludedItemsToShow = (
  excludeItems: ExcludedItemsProps,
) => {
  return Object.values(excludeItems).reduce<
    Record<string, ExcludedItemsProps[]>
  >((acc, item) => {
    const saleOrderReference = item.saleOrderReference || ''

    if (!acc[saleOrderReference]) {
      acc[saleOrderReference] = []
    }

    acc[saleOrderReference].push({
      ...item,
    } as unknown as ExcludedItemsProps)

    return acc
  }, {})
}

export const getGeneratePoQuantity = (
  saleOrderUuid: string,
  saleOrderItem: SupplyItemsPreviewResponseSaleOrderItem,
  saleOrdersToPayload: Record<
    string,
    Record<string, GeneratePurchaseOrderPayloadSupplyItemProps[]>
  >,
) => {
  let quantity = saleOrderItem?.missingQuantity || 0

  saleOrdersToPayload[saleOrderUuid][saleOrderItem?.uuid || '']?.forEach(
    (supplyItem) => {
      if (!supplyItem?.generatePo)
        quantity = quantity - (supplyItem?.quantity || 0)
    },
  )

  return Math.max(0, quantity)
}
